import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  PasswordInput,
  Edit,
  EditProps,
} from "react-admin";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import SanitizedGrid from "components/SanitizedGrid";
import RetypePasswordInput from "components/RetypePasswordInput";
import { Grid, Typography } from "@material-ui/core";
import CustomFormLabel from "components/CustomFormLabel";
import CustomEditToolbar from "components/CustomEditToolbar";
import { emailValidation, mobilePhoneNoValidation } from "utils/validation";
import CustomAddressAutoCompleteInput from "./components/CustomAddressAutoCompleteInput";
import NameInput from "../../components/NameInput";
import EmailInput from "../../components/EmailInput";

const CompanyEdit = (props: EditProps) => {
  const { id } = props;

  const breadcrumb = [
    { link: "/companies", title: "Companies" },
    { link: `/companies/${id}`, title: id },
  ];

  const transform = async (data: any) => {
    if (data.user.password === "" || data.user.passwordConfirmation === "") {
      delete data.user.password;
      delete data.user.passwordConfirmation;
    }

    return data;
  };

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <CustomFormLabel property={props} />
      <Edit {...props} transform={transform} undoable={false}>
        <SimpleForm toolbar={<CustomEditToolbar isShowDelete={false} />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Company Details</Typography>
            </Grid>

            <Grid item xs={4}>
              <NameInput label="Name" source="name" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <EmailInput label="Email" source="user.email" />
            </Grid>
            <Grid item xs={4}>
              <TextInput
                label="Mobile No."
                source="mobile"
                validate={mobilePhoneNoValidation}
              />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <PasswordInput label="Password" source="user.password" />
            </Grid>
            <Grid item xs={4}>
              <RetypePasswordInput />
            </Grid>
            <Grid item xs={4}></Grid>

            {/* <Grid item xs={4}>
              <TextInput
                label="VA Number"
                source="vaNumber"
                validate={vaNumberValidation}
              />
            </Grid>
            <Grid item xs={8}></Grid> */}

            <Grid item xs={12}>
              <Typography variant="h6">Address Detail</Typography>
            </Grid>

            <Grid item xs={4}>
              <CustomAddressAutoCompleteInput
                label="Postal Code"
                source="postalCode"
                referenceSource="locationData"
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={2}>
              <TextInput label="Unit No." source="unitNumber" />
            </Grid>
            <Grid item xs={2}>
              <TextInput label="Block No." source="blockNumber" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput label="Building Name" source="building" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput
                label="Address"
                source="address"
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>
          </SanitizedGrid>
        </SimpleForm>
      </Edit>
    </>
  );
};

export default CompanyEdit;
